import { render, staticRenderFns } from "./DataApplicationList.vue?vue&type=template&id=53176018&"
import script from "./DataApplicationList.vue?vue&type=script&lang=ts&"
export * from "./DataApplicationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports